import styled from "styled-components"

const Title = styled.h2`
color: ${(props) => props.theme.c_color_gradients.c_dark};
  &::after {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
}
`
const ZoneLibre = styled.div`
  background-color: ${(props) => props.bgColor};
`

export { Title, ZoneLibre }
